module.exports = __webpack_public_path__ + "static/media/banner1200.763df20c.webp";